export const decisioningStudioAgentsAppGroupIdDsaIdSchedule =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/schedule";

export const decisioningStudioAgentsAppGroupIdDsaIdScheduleCacheKeys =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/timing/schedule";
